import { useQuery } from '@tanstack/react-query'
import { AsaasRepository } from 'data/AsaasRepository'

export function useAsaasConfigQuery() {
	return useQuery({
		queryKey: ['asaas', 'clinic-config'],
		queryFn: () => new AsaasRepository().getClinicConfig(),
		staleTime: 30_000,
	})
}
